import { NullableTableColumns } from "@flaminem/ui-components";
import React from "react";

import { useDynamicViewSchema } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider";
import { CustomerCasesTable } from "src/dynamic-view-renderer/DynamicViewSchemaProvider/DynamicViewSchemaProvider.types";
import { HeadlessWidgetRenderer } from "src/dynamic-view-renderer/headlessWidgets/HeadlessWidgetRenderer";
import { CaseForCustomer } from "src/types/customer";

export const useGetColumns = ({
  customerCasesTable,
}: {
  customerCasesTable?: CustomerCasesTable;
}) => {
  const { headlessWidgets } = useDynamicViewSchema();

  const columns: NullableTableColumns<CaseForCustomer> = React.useMemo(() => {
    // Find the case type configuration

    const dynamicColumns = customerCasesTable?.columns.reduce((acc, column) => {
      const widget = headlessWidgets.find((w) => w.code === column.headlessWidgetCode);

      if (!widget) return acc;

      return {
        ...acc,
        [column.headlessWidgetCode]: {
          label: column.headerLabel,
          flexGrow: column.flexGrow ?? (column.width && column.width !== 1 ? 0 : 1),
          flexShrink: column.flexShrink ?? (column.width && column.width !== 1 ? 0 : 1),
          width: column.width || 1,
          className: "text-sm",
          render: (row: CaseForCustomer) => {
            return (
              <HeadlessWidgetRenderer
                widget={widget}
                data={{
                  root: row,
                  elements: row.elements,
                  propertyValues: row.properties,
                }}
              />
            );
          },
        },
      };
    }, {});

    return {
      ...dynamicColumns,
    };
  }, [headlessWidgets, customerCasesTable?.columns]);
  return columns;
};
